export default async function CreatePlanTemplateApi(
  name,
  planLevelName,
  color,
  description,
  tasks,
  kpi,
  target,
  targetDate,
  planLevelAttributes
) {
  let res = "";
  try {
    const body = {
      name: name,
      planLevelName: planLevelName,
      color: color,
      description: description,
      tasks: tasks,
      kpi: kpi,
      target: target,
      targetDate: targetDate,
      planLevelAttributes: planLevelAttributes,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plan-templates/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error create plan level: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
